import { useState, ReactNode } from "react";
import { Card, Button } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";

interface CollapsibleCardProps {
    title: ReactNode
    children: ReactNode
    style?: React.CSSProperties
    defaultCollapsed?: boolean
}

export default ({ title, children, style, defaultCollapsed = false }: CollapsibleCardProps) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    return (
        <Card
            title={title}
            bordered={false}
            style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderRadius: 8, ...style }}
            extra={
                <Button
                    type="text"
                    size="small"
                    icon={collapsed ? <DownOutlined /> : <UpOutlined />}
                    onClick={() => setCollapsed((c) => !c)}
                />
            }
        >
            {!collapsed && children}
        </Card>
    );
};
